module.exports = __webpack_public_path__ + "img/exclusive@2x.e63fba8.jpg";